const doc = [({"ext_balance":({"description":"Betaling for gebyrer"}), "reverse_charge":"Mottaker av denne tjenesten er momspliktig."})];
module.exports = doc.length <= 1 ? doc[0] : doc;